import { getJsonOffers } from './get-json-offers';
import { getTickets } from '../calculated/get-tickets';
import { shouldRenderSchema } from './should-render-schema';
import { getLocation } from './get-location';
import { renderStructureData } from './render-structured-data';
export var getStructuredData = function getStructuredData(IDs, item) {
  var _ref;

  if (item === void 0) {
    item = {};
  }

  if (!IDs) {
    return {};
  }

  var tickets = getTickets(item);
  return _ref = {}, _ref[IDs.SD_RENDER_SCHEMA] = shouldRenderSchema(item), _ref[IDs.SD_JSON_OFFERS] = getJsonOffers(item, tickets.length), _ref[IDs.SD_JSON_LOCATION] = getLocation(item), _ref[IDs.SD_JSON_RENDER] = renderStructureData(item, tickets.length), _ref;
};